export const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const WEEKDAYS_FULL = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

// Maps Portuguese weekday name to JS getDay() index
export const WEEKDAY_MAP = {
  'Domingo': 0, 'Segunda': 1, 'Terça': 2, 'Quarta': 3,
  'Quinta': 4, 'Sexta': 5, 'Sábado': 6,
};

// Get workouts for a specific date
export function getWorkoutsForDate(date, workoutAssignments) {
  const dateStr = date.toISOString().slice(0, 10);
  const dayOfWeek = WEEKDAYS_FULL[date.getDay()];
  const result = [];
  for (const a of workoutAssignments) {
    if (!a.active) continue;
    if (a.type === 'periodizacao' && a.treinos?.length > 0) {
      // For periodizations, check each sub-workout individually
      for (const treino of a.treinos) {
        const tStart = treino.startDate || a.startDate;
        const tEnd = treino.endDate || a.endDate;
        if (!tStart || !tEnd) continue;
        if (dateStr < tStart || dateStr > tEnd) continue;
        if ((treino.scheduledDays || []).includes(dayOfWeek)) {
          result.push({ ...a, workoutTemplateName: treino.name || a.name, timeOfDay: treino.timeOfDay || a.timeOfDay });
        }
      }
    } else {
      if (!a.startDate || !a.endDate) continue;
      if (dateStr < a.startDate || dateStr > a.endDate) continue;
      if ((a.scheduledDays || []).includes(dayOfWeek)) result.push(a);
    }
  }
  return result;
}

// Get diet assignments active on a specific date
export function getDietsForDate(date, dietAssignments) {
  const dateStr = date.toISOString().slice(0, 10);
  return dietAssignments.filter(a => {
    if (!a.active) return false;
    return dateStr >= a.startDate && dateStr <= a.endDate;
  });
}

// Get week dates (Mon to Sun) containing currentDate
export function getWeekDates(currentDate) {
  const d = new Date(currentDate);
  const day = d.getDay();
  const monday = new Date(d);
  monday.setDate(d.getDate() - (day === 0 ? 6 : day - 1));
  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    return date;
  });
}

// Get month dates (null padding for leading weekday cells)
export function getMonthDates(currentDate) {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const startPad = firstDay.getDay(); // 0=Sun
  const days = [];
  for (let i = 0; i < startPad; i++) days.push(null);
  for (let d = 1; d <= lastDay.getDate(); d++) days.push(new Date(year, month, d));
  return days;
}
